// Entry point. Register the service worker (offline shell), init the (stubbed)
// auth identity, then mount the app. Order matters: auth init is cheap and
// offline-safe in Slice 1, so the UI never blocks on network.

import { registerSW } from 'virtual:pwa-register';
import { mountApp } from './app';
import { initAuth } from './auth/auth';
import { initTheme } from './ui/theme';
import './styles.css';

// Apply the saved appearance before mountApp() paints, so a light-theme user
// never sees a flash of the dark default.
initTheme();

registerSW({ immediate: true });

const root = document.getElementById('app');
if (root) {
  initAuth()
    .catch((e) => console.warn('auth init (stub) failed, continuing', e))
    .finally(() => {
      void mountApp(root);
    });
}
